import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { BannerTickerItem } from '../../core/models/interfaces-general';

@Component({
    selector: 'app-banner',
    standalone: true,
    imports: [CommonModule, RouterLink],
    templateUrl: './banner.component.html',
    styles: [`
    /* Animación de rotación para el sello/badge */
    @keyframes spin-slow {
      from { transform: rotate(0deg); }
      to { transform: rotate(360deg); }
    }
    .animate-spin-slow {
      animation: spin-slow 15s linear infinite;
    }

    /* Animación de la cinta infinita (Ticker) */
    @keyframes ticker {
      0% { transform: translateX(0); }
      100% { transform: translateX(-50%); }
    }
    .animate-ticker {
      display: flex;
      width: max-content;
      animation: ticker 25s linear infinite;
    }
    .animate-ticker:hover {
      animation-play-state: paused;
    }
  `]
})
export class BannerComponent {
    // Entradas dinámicas
    @Input({ required: true }) imageUrl: string = '';
    @Input() titleLine1: string = 'flores';
    @Input() titleLine2: string = 'amarillas';
    @Input() subtitleQuote: string = 'amar y ya';
    @Input() badgeText: string = 'Envía hoy a todo Lima y Callao';
    @Input() actionButtonText: string = 'ENVÍA AHORA';

    // Cinta de texto rotativa
    @Input() tickerItems: BannerTickerItem[] = [
        { text: 'FLORES Y REGALOS PARA HOY', url: '/categoria/hoy' }
    ];

    // Evento cuando se presiona el botón principal
    @Output() actionClick = new EventEmitter<void>();

    onActionButtonClick() {
        this.actionClick.emit();
    }
}